import { AssetRecordType, Box2d, Editor, VecLike, createShapeId } from '@tldraw/tldraw'
import { getImageSizeFromSrc } from 'components/Design/UploadsTab/getImageSizeFromSrc'
import { noCacheUrl } from 'components/VisualStudioPlayground/Shapes/ImageShape/helpers'
import { DraggableImagePayload } from 'components/Design/DraggableShape/Types'
import { reportError } from 'utils/error'
import { downloadIcon as downloadFreepikIcon } from 'components/Design/ElementsTab/components/Freepik'
import { downloadIcon as downloadNounProjectIcon } from 'components/Design/ElementsTab/components/NounProjectGrid'
import { FrameShape } from 'components/VisualStudioPlayground/Shapes/FrameShape/Types'

const getFileUrlFromPayload = async ({ file, special_type, special_payload }: DraggableImagePayload) => {
  try {
    if (special_type === 'freepik') {
      return await downloadFreepikIcon(special_payload.id)
    }

    if (special_type === 'noun_project') {
      return await downloadNounProjectIcon(special_payload.id)
    }
  } catch (error) {
    reportError(error, { severity: 'error' })
  }

  return file.source_url
}

export const handleImageDrop = async (
  editor: Editor,
  localDropPoint: VecLike,
  targetFrame: FrameShape,
  payload: DraggableImagePayload,
) => {
  const { file } = payload
  const fileUrl = await getFileUrlFromPayload(payload)

  let assetDimensions = file.width && file.height ? { width: file.width, height: file.height } : undefined
  if (!assetDimensions) {
    const size = await getImageSizeFromSrc(noCacheUrl(file.source_url))
    assetDimensions = { width: size.w, height: size.h }
  }
  if (assetDimensions.width === Infinity || assetDimensions.height === Infinity) {
    assetDimensions = { width: 100, height: 100 }
  }
  const assetId = AssetRecordType.createId(file.source_url)
  const asset = AssetRecordType.create({
    id: assetId,
    type: 'image',
    typeName: 'asset',
    props: {
      name: fileUrl,
      src: fileUrl,
      w: assetDimensions.width,
      h: assetDimensions.height,
      mimeType: file.mime_type,
      isAnimated: false,
    },
  })
  editor.createAssets([asset])

  const id = createShapeId()
  const box = Box2d.From({ x: 0, y: 0, w: assetDimensions.width, h: assetDimensions.height }).scale(
    assetDimensions.width / payload.props.w,
  )
  editor.createShape({
    id,
    type: 'image',
    parentId: targetFrame.id,
    x: localDropPoint.x,
    y: localDropPoint.y,
    props: {
      assetId: asset.id,
      w: box.w,
      h: box.h,
      isLogo: payload.props.isLogo ?? false,
    },
  })
  editor.select(id)
}
